import { styled, Theme } from '@mui/material/styles'

interface DotProps {
  backgroundColor?: string | ((theme: Theme) => string)
}
export const Dot = styled('div')<DotProps>(({ theme, backgroundColor }) => {
  const rawColor =
    backgroundColor && typeof backgroundColor === 'function'
      ? backgroundColor(theme)
      : (backgroundColor ?? '#000')
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    margin: theme.spacing(-1, 1),
    borderRadius: '50%',
    backgroundColor: rawColor,
    color: theme.palette.getContrastText(rawColor),
  }
})
